import { render, staticRenderFns } from "./CommandDia.vue?vue&type=template&id=b39c2242&scoped=true"
import script from "./CommandDia.vue?vue&type=script&lang=js"
export * from "./CommandDia.vue?vue&type=script&lang=js"
import style0 from "./CommandDia.vue?vue&type=style&index=0&id=b39c2242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39c2242",
  null
  
)

export default component.exports